import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const FullLoader = () => (
  <div className="flex min-h-[60vh] items-center justify-center" data-testid="page-loader">
    <Loader2 className="h-7 w-7 animate-spin text-[#C20500]" />
  </div>
);

export const ProtectedRoute = ({ role, children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <FullLoader />;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/portal"} replace />;
  return children;
};
